import React from 'react';
import Wrapeer from './Wrapper';

export default function Instruction(){
    return(
        <Wrapeer>
            <div className="instruction">
                Drag and drop to reorder list
            </div>
        </Wrapeer>
    )
}